import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, BarElement, ArcElement } from 'chart.js';
import './DataAnalytics.scss';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, BarElement, ArcElement);

const DataAnalytics = ({ setTitle }) => {
  useEffect(() => {
    setTitle('EarthVerse CRM - 數據統計');
  }, [setTitle]);

  const [timeRange, setTimeRange] = useState('7d');

  // Mock data
  const licenseUsageData = {
    labels: ['Harry', 'Zoey', '南港國小', '南港國小2'],
    datasets: [
      {
        label: 'License Usage (%)',
        data: [85, 62, 78, 90, 55],
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      }
    ]
  };

  const averageExperienceDurationData = {
    labels: ['VR Experience', 'AR Experience', 'Interactive 3D', '360° Video', 'Mixed Reality'],
    datasets: [
      {
        label: 'Average Duration (minutes)',
        data: [25, 15, 20, 10, 30],
        backgroundColor: 'rgba(255, 159, 64, 0.6)',
      }
    ]
  };

  const popularContentData = {
    labels: ['台灣特有種', '台灣特有種2', '台灣特有種3', '台灣特有種4', '台灣特有種5'],
    datasets: [
      {
        label: 'Views',
        data: [5000, 4200, 3800, 3500, 3000],
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
      }
    ]
  };

  const popularExperienceTypesData = {
    labels: ['🧊4DGS', '🧊3DGS', '🎥HD', '🎥3DV', '🎥3DH'],
    datasets: [
      {
        data: [30, 25, 20, 15, 10],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
        hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF']
      }
    ]
  };

  // Mock license expiration data
  const licenseExpirations = [
    { id: 1, customer: 'Harry', expirationDate: '2023-08-15' },
    { id: 2, customer: '南港國小', expirationDate: '2023-09-01' },
    { id: 3, customer: '南港國小2', expirationDate: '2023-09-10' },
  ];

  return (
    <div className="data-analytics">
      <h2>統計</h2>
      <div className="time-range-selector">
        {/* <button onClick={() => setTimeRange('7d')} className={timeRange === '7d' ? 'active' : ''}>Last 7 days</button> */}
        {/* <button onClick={() => setTimeRange('30d')} className={timeRange === '30d' ? 'active' : ''}>Last 30 days</button> */}
        {/* <button onClick={() => setTimeRange('90d')} className={timeRange === '90d' ? 'active' : ''}>Last 90 days</button> */}
      </div>
      <div className="license-expiration">
        <h3>授權到期提醒</h3>
        <ul>
          {licenseExpirations.map((license) => (
            <li key={license.id}>
              <span>{license.customer}  Expires on {license.expirationDate}</span>
              <Link to={`/permissions/${license.id}/edit`} className="edit-link">前往編輯</Link>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="chart-grid">
        <div className="chart">
          <h3>個別客戶的授權使用率</h3>
          <Bar data={licenseUsageData} />
        </div>
        {/* <div className="chart">
          <h3>平均體驗時長</h3>
          <Bar data={averageExperienceDurationData} />
        </div> */}
        <div className="chart">
          <h3>受歡迎的內容</h3>
          <Bar data={popularContentData} />
        </div>
        <div className="chart">
          <h3>受歡迎的體驗類型</h3>
          <Doughnut data={popularExperienceTypesData} />
        </div>
      </div>
    </div>
  );
};

export default DataAnalytics;